import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Pause = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20, fill = 'none' }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
      <path
        d="M1.66675 2.66667V17.3333C1.66675 17.8856 2.11446 18.3333 2.66675 18.3333L7.33342 18.3333C7.8857 18.3333 8.33341 17.8856 8.33341 17.3333V2.66666C8.33341 2.11437 7.8857 1.66666 7.33341 1.66666L2.66675 1.66667C2.11446 1.66667 1.66675 2.11438 1.66675 2.66667Z"
        fill={color}/>
      <path
        d="M11.6667 2.66667V17.3333C11.6667 17.8856 12.1145 18.3333 12.6667 18.3333L17.3334 18.3333C17.8857 18.3333 18.3334 17.8856 18.3334 17.3333V2.66666C18.3334 2.11437 17.8857 1.66666 17.3334 1.66666L12.6667 1.66667C12.1145 1.66667 11.6667 2.11438 11.6667 2.66667Z"
        fill={color}/>
      </svg>
    )
  },
)

export default Pause
